import { createSelector } from 'reselect';
import { isAppAuthSelector } from './AuthSelectors';
export const allPromotionsSelector = ({
  promotions
}) => promotions;
export const requiredOnboardingSelector = state => {
  const {
    requiredOnboarding
  } = state;
  return requiredOnboarding;
};
export const productInventorySelector = ({
  productInventory
}) => productInventory;
export const productDataSelector = ({
  abstractedProducts
}) => {
  return abstractedProducts;
};
export const gatesSelector = state => {
  if (isAppAuthSelector(state)) {
    const {
      auth: {
        gates,
        user: {
          scopes = []
        }
      }
    } = state;
    return [...gates, ...scopes];
  }
  const {
    publicFeatureFlags
  } = state;
  return publicFeatureFlags !== null && publicFeatureFlags !== void 0 ? publicFeatureFlags : [];
};
export const transformState = createSelector(
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore ignore the error where useSelector is limited to 12 selectors
[productDataSelector, allPromotionsSelector, requiredOnboardingSelector, gatesSelector, productInventorySelector], (productData, promotions, requiredOnboarding, gates, productInventory) => ({
  productData,
  promotions,
  requiredOnboarding,
  gates,
  productInventory
}));